import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../config';

const AdminLogin = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${API_URL}/login`, { username, password });
            if (response.data.success) {
                localStorage.setItem('isAdmin', 'true');
                navigate('/admin');
            }
        } catch (err) {
            setError('Identifiants invalides');
        }
    };

    return (
        <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
            <div className="card shadow-lg p-4 p-md-5 border-0 rounded-4" style={{ width: '100%', maxWidth: '450px' }}>
                <h2 className="mb-2 fw-bold text-dark">Admin Login</h2>
                <p className="text-muted small mb-4">Entrez vos identifiants pour accéder à l'interface de gestion.</p>
                {error && <div className="alert alert-danger border-0 small py-2">{error}</div>}
                <form onSubmit={handleLogin}>
                    <div className="mb-3">
                        <label className="form-label small fw-bold">Nom d'utilisateur</label>
                        <input 
                            type="text" 
                            className="form-control py-2 shadow-none border-secondary border-opacity-25" 
                            value={username} 
                            onChange={(e) => setUsername(e.target.value)} 
                            required 
                            placeholder="Ex: admin"
                        />
                    </div>
                    <div className="mb-4">
                        <label className="form-label small fw-bold">Mot de passe</label>
                        <input 
                            type="password" 
                            className="form-control py-2 shadow-none border-secondary border-opacity-25" 
                            value={password} 
                            onChange={(e) => setPassword(e.target.value)} 
                            required 
                            placeholder="••••••••"
                        />
                    </div>
                    <button type="submit" className="btn btn-warning w-100 py-3 fw-bold text-uppercase rounded-3 shadow-sm mt-2">
                        Se connecter
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;
